import Vue from 'vue';
import AutoRouter from './automation-router';
import Router from 'vue-router';

Vue.use(Router);
Vue.use(AutoRouter, {
  config: {
    meta: {
      auth: true,
    }
  },
  errPath: '/home/page/home',
});

const routes = Vue.prototype.$autoRouter.routes;

console.log(routes);

let router = new Router({
  // mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return {x: 0, y: 0}
  }
});

router.beforeEach((to, from, next) => {
  document.getElementById('app').scrollTop = 0;
  return next();
});

export default router;
